import React from 'react';

export default function ContactModal({ content, onClose }) {
  if (!content) return null;
  const { contact, links } = content;
  const showFields = contact.fieldsVisible === true;
  const f = contact.fields;

  return (
    <div
      className="tl-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="tl-contact-title"
      onClick={onClose}
    >
      <div
        className={`tl-modal${!showFields ? ' tl-modal-social-only' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="tl-modal-close" onClick={onClose} aria-label="Закрити">
          ×
        </button>
        <div className="tl-modal-head">
          <h2 id="tl-contact-title" className="tl-serif tl-h2">
            {contact.title}
          </h2>
          <p className="tl-lead" style={{ marginInline: 'auto' }}>
            {contact.subtitle}
          </p>
        </div>

        <div className="tl-modal-grid">
          <div>
            <p className="tl-eyebrow">{contact.socialHeading}</p>
            <a
              className="tl-social-card"
              href={links.telegram}
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>Telegram</strong>
              <span className="accent">{contact.telegramLabel}</span>
              <br />
              <small>{contact.telegramHint}</small>
            </a>
            <a
              className="tl-social-card"
              href={links.instagram}
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>Instagram</strong>
              <span className="accent">{links.instagramHandle}</span>
              <br />
              <small>{contact.instagramHint}</small>
            </a>
            <p className="tl-ready-note">{contact.responseNote}</p>
          </div>

          <div className={`tl-form-card${showFields ? '' : ' tl-form-hidden'}`} aria-hidden={!showFields}>
            <h3 className="tl-serif" style={{ marginTop: 0 }}>
              {contact.formTitle}
            </h3>
            <p className="tl-lead" style={{ marginBottom: '1rem', fontSize: '0.95rem' }}>
              {contact.formSubtitle}
            </p>
            <form
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className="tl-field">
                <label htmlFor="tl-name">{f.name.label}</label>
                <input id="tl-name" name="name" placeholder={f.name.placeholder} disabled={!showFields} />
              </div>
              <div className="tl-field">
                <label htmlFor="tl-email">{f.email.label}</label>
                <input
                  id="tl-email"
                  name="email"
                  type="email"
                  placeholder={f.email.placeholder}
                  disabled={!showFields}
                />
              </div>
              <div className="tl-field">
                <label htmlFor="tl-goal">{f.goal.label}</label>
                <select id="tl-goal" name="goal" defaultValue="" disabled={!showFields}>
                  <option value="" disabled>
                    {f.goal.placeholder}
                  </option>
                  {f.goal.options.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>
              <div className="tl-field">
                <label htmlFor="tl-message">{f.message.label}</label>
                <textarea
                  id="tl-message"
                  name="message"
                  placeholder={f.message.placeholder}
                  disabled={!showFields}
                />
              </div>
              <button type="submit" className="tl-btn tl-btn-primary" disabled={!showFields}>
                {f.submit}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
